import wretch from 'wretch';

import { IPromoModel, IMyAccountUrl } from '../types';

export async function apiGetPromo(id: string): Promise<IPromoModel> {
  return wretch(`/api/special-offers/${id}`).get().json();
}

export async function apiGetLeadPromo(
  id: string,
  leadId: number
): Promise<IPromoModel> {
  return wretch(`/api/leads/${leadId}/special-offers/${id}`).get().json();
}

export async function apiGetMyAccountURLs(): Promise<IMyAccountUrl[]> {
  return wretch('/api/special-offers/my-account-urls').get().json();
}

export async function apiCreatePromo(model: IPromoModel): Promise<IPromoModel> {
  return wretch('/api/special-offers').post(model).json();
}

export async function apiUpdatePromo(
  id: string,
  model: IPromoModel
): Promise<IPromoModel> {
  return wretch(`/api/special-offers/${id}`).put(model).json();
}
